import initialState from './initialState';
import {SET_AUTH, LOGOUT} from '../actions/AuthActions';

export default function AuthReducer(state = initialState.auth, action) {
    switch (action.type) {
        case SET_AUTH:
            const {data} = action.payload;
            return {...data};
        case LOGOUT:
            return {};
        default:
            return state;
    }
}
